import { styled } from '@mui/material';
import { Container, Typography, Button, Image } from 'core/common/ui/ui-kit';

export const ContainerStyled = styled(Container)``;

export const SectionStyled = styled('section')`
  margin-bottom: 52px;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-bottom: 75px;
  }
`;

export const TitleStyled = styled(Typography)`
  margin-bottom: 52px;
  text-align: center;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-bottom: 75px;
  }
`;

export const ImageStyled = styled(Image)`
  display: block;
  margin-right: auto;
  margin-bottom: 52px;
  margin-left: auto;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-bottom: 75px;
  }
`;

export const ButtonStyled = styled(Button)`
  width: 100%;
  max-width: 380px;
  margin-right: auto;
  margin-bottom: 52px;
  margin-left: auto;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-bottom: 75px;
  }
`;
